import { createUseStyles, Styles } from '@pff-consumer/tweed-ui/web-styles'

interface CreateAccountStyles {
  createAccountContainer: Styles
  button: Styles
}

export const useStyles = createUseStyles<CreateAccountStyles>((theme) => {
  return {
    createAccountContainer: {
      display: 'flex',
      justifyContent: 'center',
      padding: theme.calcUnit(theme.spacing.s5),
    },
    button: {
      marginTop: theme.calcUnit(theme.spacing.s2),
    },
  }
})
